import React from 'react';
import { useInView } from 'react-intersection-observer';
import LottieAnimation from 'components/LottieAnimation';
import {Heading} from 'components/Heading';
import {CallToAction} from 'components/CallToAction';
import { GatsbyImage, getImage, withArtDirection, ImageDataLike, StaticImage } from 'gatsby-plugin-image'

import animationData from './data/notification-center-lottie-data.json';

const LINKS = { inAppDocs: '/docs/in-app-notifications' };
const TITLE = 'Fully featured notification center in minutes';
const DESCRIPTION =
  'Build a real-time notification center using our embeddable components or connect your custom UI with our notification feed API.';
const BUTTON_TEXT = 'Read Docs';

  export default function NotificationCenter({ allNotificationCenter, googleImages })  {
    const { title,  img, subtitle,features, style='',enable } = allNotificationCenter
       if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
    const googleImage = img && googleImages && googleImages[0] && googleImages[0].filter((image) => { if (image.name == img) return image })[0]
    const googleImage2 = img && googleImages && googleImages[1] && googleImages[1].filter((image) => { if (image.name == img) return image })[0]
    const gatsbyImage = googleImage && getImage(googleImage)
    const gatsbyImage2 = googleImage2 && getImage(googleImage2)
  const [animationWrapperRef, isAnimationWrapperInView] = useInView({
    threshold: 0.6,
  });

  const lottieData = {
    lottieOptions: {
      animationData,
      loop: true,
    },
    isInView: isAnimationWrapperInView,
  };

  return (
    <section className="notification-center safe-paddings bg-gray-2 pb-30 pt-40 lg:pt-32 lg:pb-24 md:pt-28 md:pb-18 sm:pt-18 sm:pb-12">
      <div className="container lg:grid lg:grid-cols-12  xl:gap-x-10 lg:gap-x-7 md:gap-x-5 lg:items-center flex flex-col">
        <div
          className="relative lg:col-start-1 lg:col-end-8 lg:order-1 order-2 md:mt-11 md:w-full mt-8"
          ref={animationWrapperRef}
        >
          <LottieAnimation {...lottieData} />
        </div>

        <div className="lg:col-start-9 lg:col-end-13 xl:col-start-8 order-1 text-center">
          <Heading
            size="xl"
            tag="h2"
            className="leading-tight lg:text-4xl sm:text-3xl"
            theme="white"
          >
            {TITLE}
          </Heading>
          <p className="mt-5 text-lg font-book leading-snug text-primary lg:mt-3 lg:text-base">
            {DESCRIPTION}
          </p>
          <CallToAction className="mt-7 md:mt-6" size="sm" theme="gray-outline" to={LINKS.inAppDocs}>
            {BUTTON_TEXT}
          </CallToAction>
        </div>
      </div>
    </section>
  );
};

